module.exports = __webpack_public_path__ + "img/logo.3fe761ab.png";